module.exports = __webpack_public_path__ + "media/img/patterns/grid-horizontal-rtl-short-dark-c536484d633c932c4d77629224436d08.png";